import { RespondentSPoCAssignmentValidationLoader } from "./RespondentSPoCAssignmentValidationLoader";
import { RespondentSPoCAssignmentValidationResult } from "./RespondentSPoCAssignmentValidationResult";
import {
  Dialog,
  FoundationColorTokens,
  Spacing,
  Typography,
} from "@surya-digital/leo-reactjs-material-ui";
import React from "react";
import { observer } from "mobx-react";
import { TFunction } from "i18next";
import { Instance } from "mobx-state-tree";
import { RespondentSPoCMappingStore } from "../../store/RespondentSPoCMappingStore";
import { DeveloperErrorFlow } from "@pulse/shared-components";

interface RespondentSPoCAssignmentValidationDialogProps {
  t: TFunction;
  tokens: FoundationColorTokens<string>;
  typography: Typography;
  spacing: Spacing;
  respondentSPoCMappingStore: Instance<
    typeof RespondentSPoCMappingStore
  > | null;
}

export const RespondentSPoCAssignmentValidationDialog = observer(
  ({
    t,
    tokens,
    typography,
    spacing,
    respondentSPoCMappingStore,
  }: RespondentSPoCAssignmentValidationDialogProps): React.ReactElement => {
    if (respondentSPoCMappingStore === null) {
      return <DeveloperErrorFlow />;
    }

    const getSecondaryButtonText = (): string | undefined => {
      if (respondentSPoCMappingStore.isFileValidated) {
        return t("common.done");
      }
      return undefined;
    };

    const getValidationDialogContent = (): React.ReactElement => {
      if (respondentSPoCMappingStore.isRPCLoading) {
        return (
          <RespondentSPoCAssignmentValidationLoader
            t={t}
            spacing={spacing}
            tokens={tokens}
            typography={typography}
            respondentSPoCMappingStore={respondentSPoCMappingStore}
          />
        );
      } else if (respondentSPoCMappingStore.isFileValidated) {
        return (
          <RespondentSPoCAssignmentValidationResult
            t={t}
            spacing={spacing}
            tokens={tokens}
            typography={typography}
            respondentSPoCMappingStore={respondentSPoCMappingStore}
          />
        );
      } else {
        return <></>;
      }
    };

    return (
      <Dialog
        open={
          respondentSPoCMappingStore.isRespondentSPoCAssignmentValidationDialogVisible
        }
        title={t("projects.respondentList.spocAssignmentValidationTitle")}
        secondaryButtonText={getSecondaryButtonText()}
        isSecondaryButtonDisabled={respondentSPoCMappingStore.isRPCLoading}
        contentPadding={spacing.spaceLG}
        onSecondaryButtonClick={async () => {
          if (!respondentSPoCMappingStore.isRPCLoading) {
            respondentSPoCMappingStore.setIsRespondentSPoCAssignmentValidationDialogVisible(
              false,
            );
          }
        }}
        isPrimaryButtonDisabled={true}
        onPrimaryButtonClick={async () => {}}
        primaryButtonText={undefined}
        width="560px"
      >
        {getValidationDialogContent()}
      </Dialog>
    );
  },
);
